import { StarRating } from "./StarRating";

/**
 * Vendor card used in the marketplace home marquee / manual-scroll rail.
 * Extracted from MarketplaceHome.jsx (Session 30, PD-2).
 */
export function VendorCard({ vendor, onClick, onReturns }) {
  return (
    <div className="mp-vendor-card" onClick={onClick} data-testid={`vendor-card-${vendor.id}`}>
      <div className="mp-vendor-banner">
        {vendor.banner_url && (
          <img
            className="mp-vendor-banner-img"
            src={vendor.banner_url}
            alt=""
            data-testid={`vendor-banner-${vendor.id}`}
          />
        )}
        <div className="mp-vendor-avatar" data-testid={`vendor-avatar-${vendor.id}`}>
          {vendor.avatar_url ? (
            <img src={vendor.avatar_url} alt={vendor.store_name} />
          ) : (
            /* A storefront with no name or no categories set used to take the WHOLE marketplace
               down with "Cannot read properties of undefined" — one unfinished store, and nobody
               could shop (owner, Sep 2026). Nothing here may assume a field was filled in. */
            (vendor.store_name || '?')[0]
          )}
        </div>
      </div>
      <div className="mp-vendor-info">
        <p className="mp-vendor-name">{vendor.store_name}</p>
        <p className="mp-vendor-cat">{(vendor.categories || [])[0] || '\u00a0'}</p>
        <StarRating value={vendor.rating_avg} count={vendor.rating_count} />
        {onReturns && (
          <button
            type="button"
            className="mp-vendor-returns"
            data-testid={`vendor-returns-link-${vendor.id}`}
            onClick={(e) => { e.stopPropagation(); onReturns(); }}
          >
            Return policy
          </button>
        )}
      </div>
    </div>
  );
}
